/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Train_BodyInputs */

const en_how_page_train_body = /** @type {(inputs: How_Page_Train_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach's plan sets the weight and the reps, the rest counts itself down, and what you did last time sits right beside it.`)
};

const pl_how_page_train_body = /** @type {(inputs: How_Page_Train_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan od trenera podaje ciężar i powtórzenia, przerwa odlicza się sama, a obok widzisz, co zrobiłeś ostatnio.`)
};

/**
* | output |
* | --- |
* | "Your coach's plan sets the weight and the reps, the rest counts itself down, and what you did last time sits right beside it." |
*
* @param {How_Page_Train_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_train_body = /** @type {((inputs?: How_Page_Train_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Train_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_train_body(inputs)
	return en_how_page_train_body(inputs)
});